import { Box, IconButton, Typography } from '@mui/material';
import Pencil from '../icons/Pencil.tsx';
import { styles } from './styles';
import { getErrorKey } from '~/helpers/utils.ts';
import { commonStyles } from '~/theme/styles/commonStyles.ts';

interface ITitlePencilFieldProps {
  onClick: () => void;
  errorMessage?: string;
  title: string;
  dataName?: string;
}

const TitlePencilField = ({ onClick, errorMessage, title, dataName }: ITitlePencilFieldProps) => {
  const errorDataTestId = [`${dataName}`, getErrorKey(errorMessage || '')]
    .filter(Boolean)
    .join('-');

  return (
    <Box data-name={dataName} sx={{ width: '100%', position: 'relative' }}>
      <Box sx={{ ...commonStyles.centerFlexContainer, gap: 1 }}>
        <Typography variant="body1" onClick={onClick} sx={{ cursor: 'pointer' }}>
          {title}
        </Typography>
        <IconButton sx={styles.iconButton} onClick={onClick} data-testid={`pencilBtn-${dataName}`}>
          <Pencil isError={!!errorMessage} isButton />
        </IconButton>
      </Box>

      <Typography
        variant="caption"
        sx={{ color: 'error.main', display: 'block', position: 'absolute' }}

        data-testid={errorDataTestId}
      >
        {errorMessage}
      </Typography>
    </Box>
  );
};

export default TitlePencilField;
